import { Injectable } from '@angular/core';
import { CheckoutBillingAdapter } from './checkout.billing.adapter';
import { Observable } from 'rxjs';

@Injectable()
export class CheckoutBillingConnector {
  constructor(protected adapter: CheckoutBillingAdapter) {}

  setBillingAddress(userId: string, cartId: string, billingAddressData: any): Observable<any> {
    return this.adapter.setBillingAddress(userId, cartId, billingAddressData);
  }

  selectBillingAddress(userId: string, cartId: string, addressId: string): Observable<any> {
    return this.adapter.selectBillingAddress(userId, cartId, addressId);
  }
}
